import { useCallback, useState } from 'react';

import constate from 'constate';

const STORAGE_KEY = 'sidebarVersion';

type SidebarVersion = 'new' | 'legacy';

function useSidebarVersion() {
    const [sidebarVersion, setSidebarVersion] = useState<SidebarVersion>(
        (window.localStorage.getItem(STORAGE_KEY) as SidebarVersion) || 'new'
    );

    const toggleSidebarVersion = useCallback(() => {
        setSidebarVersion((prev) => {
            const next = prev === 'new' ? 'legacy' : 'new';
            window.localStorage.setItem(STORAGE_KEY, next);
            return next;
        });
    }, []);

    return { sidebarVersion, toggleSidebarVersion };
}

const [SidebarVersionContextProvider, useSidebarVersionContext] = constate(useSidebarVersion);

export { SidebarVersionContextProvider, useSidebarVersionContext };
